export default __webpack_public_path__ + "static/media/Gears.9da84929.svg";